import { Component, OnInit,ViewChild,ElementRef  } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { UserService } from '../../service/user.service';
import { LoaderService } from '../../service/loader.service';
import { ChartService } from '../../service/chart.service';
import { BaseComponent } from 'src/app/shared/components/base.component';
import { ChartType, ChartDataSets, ChartOptions,ChartData } from 'chart.js';
import { log } from 'console';
@Component({
  selector: 'app-category-popup',
  templateUrl: './category-popup.component.html',
  styleUrls: ['./category-popup.component.scss']

})
export class CategoryPopupComponent extends BaseComponent implements OnInit {
 @ViewChild('doughnutSubmittedOrder') doughnutSubmittedOrder!: ElementRef;
  chart: any;

  items = [];

  fromDate: any;
  toDate: any;
  reportPeriod: any;
  year: any;
  month: any;
  week: any;
  colorCount:number;
  currentYear=new Date().getFullYear();
  defaultChartData: any= null;
  defaultChartDataLength: number= null;

  // public barChartOptions:any = {
  //   scaleShowVerticalLines: false,
  //   responsive: true
  // };
    public barChartOptions = {
    scales: {
      xAxes: [{ 
        categoryPercentage: 0.7,   // default ~0.8; lower makes bars wider
        barPercentage: 0.9,
        ticks: { beginAtZero: true }
      }]
      // ,
      // yAxes: [{ ticks: { beginAtZero: true } }]
    },
    elements: {
      rectangle: {
        minBarLength: 8,
        borderWidth: 1
      }
    },
    // ... tooltips/hover from above
  };
  chartData: number[]=[];
  public barChartLabels:string[] =[]
  public barChartData:any[] =[];
  public barChartType:string = 'bar';
  public barChartLegend:boolean = false;
  public barChartColors:Array<any> = [];


  public doughnutChartLabels:string[] =[];
  public doughnutChartData:any[] =[];
  public doughnutChartType: ChartType = 'doughnut';
  public doughnutColor: string[] = [];
  public doughnutDatasets: any[];
  public doughnutLabelArray: any[]=[];
  reportfromDate: any;
  reportToDate: any;
  doughnutChartColors:any[] =[];

  
  constructor( public activeModal: NgbActiveModal
        ,private loaderService: LoaderService
        ,private userService: UserService
        ,private chartService:ChartService) { 

    
        super();
  }

  ngOnInit(): void {
  }

  ngAfterViewInit() {
   this.CreateChart();


}
  CreateChart()
  {
   
  for (let i = 0; i < this.defaultChartData.length; i++) {
          this.barChartColors=[{backgroundColor:'#74acac'}] ;
          this.barChartLabels.push(this.defaultChartData[i].serviceName)
          this.chartData.push(this.defaultChartData[i].totalCount)
    }
    this.barChartData=[{data:this.chartData,label:(new Date()).getFullYear()}];
  }

  CreateChartSelectedDateWise()
  {
     console.log("CreateChartSelectedDateWise");

    this.barChartData =[];
    this.chartData=[];
    this.barChartLabels=[];
    this.barChartData=[];
    this.loaderService.show();
    console.log("this.items",this.items);
    //this.chartService.renderChart(this.chart,this.doughnutSubmittedOrder,this.doughnutChartLabels,this.doughnutChartData,this.doughnutColor);
    if(this.items.length>0)
    {
      this.userService.GetDashboardPopupReport(this.items[0]["reportFromDate"],this.items[0]["reportToDate"],this.items[0]["period"],this.items[0]["year"],this.items[0]["month"],"GetCategoryReport",null,null,this.items[0]["serviceCategory"]).subscribe(
      ress => {
        this.loaderService.hide();
         if (ress.successed) {
          var data = ress.data;
             //console.log("success");
            
             console.log(data.dashboardPopupDoughChart);
            //#region  Barchart
            if(data.dashboardPopupBarChart[0].subColumnName === "undefined" || data.dashboardPopupBarChart[0].subColumnName === null){
            console.log("if");
              this.barChartLegend=false;
                         
              const datasets: any[] = [];
              const backgroundColors: string[] = [];
              const hoverColors: string[] = [];

              for (let i = 0; i < data.dashboardPopupBarChart.length; i++) {
               
                  const ColumnName=data.dashboardPopupBarChart[i].columnName;
                  this.chartData.push(data.dashboardPopupBarChart[i].columnValue);                  
                  this.barChartLabels.push(ColumnName);
                  const colors = this.chartService.getChartColors(i);
                  
                  backgroundColors.push(colors.base);
                  hoverColors.push(colors.hover);

                  console.log("val",data.dashboardPopupBarChart[i].columnValue);                   
              }
              datasets.push({
                    label: "Categories",//`${this.barChartLabels}`,
                    data: this.chartData,
                    backgroundColor: backgroundColors, // unique color per dataset
                    hoverBackgroundColor: hoverColors 
                  });
             
              this.barChartLabels = this.barChartLabels;
              this.barChartData = datasets;
            
            }
            
            else if(data.dashboardPopupBarChart[0].serviceCategoryName !== undefined && data.dashboardPopupBarChart[0].serviceCategoryName !== null){
                    console.log("Else If ",data.dashboardPopupBarChart[0].serviceCategoryName);
                   
                  const subColumnName=[];
                  const columnName=[];
                  const serviceCategoryName=[];

                  this.barChartData=[];
                  this.barChartLegend=true;

                  const distinctColumn = data.dashboardPopupBarChart.filter(
                    (dashboardPopupBarChart, i, arr) => arr.findIndex(t => t.columnName === dashboardPopupBarChart.columnName) === i
                  );

                  for (let dc = 0; dc < distinctColumn.length; dc++) {
                    columnName.push(distinctColumn[dc].columnName);
                  }

                  const distinctSubColumn = data.dashboardPopupBarChart.filter(
                    (dashboardPopupBarChart, i, arr) => arr.findIndex(t => t.subColumnName === dashboardPopupBarChart.subColumnName) === i
                  );
                  for (let dsc = 0; dsc < distinctSubColumn.length; dsc++) {
                    subColumnName.push(distinctSubColumn[dsc].subColumnName);
                  }

                  const distinctserviceCategory = data.dashboardPopupBarChart.filter(
                    (dashboardPopupBarChart, i, arr) => arr.findIndex(t => t.serviceCategoryName === dashboardPopupBarChart.serviceCategoryName) === i
                  );
                  for (let dsc = 0; dsc < distinctserviceCategory.length; dsc++) {
                    serviceCategoryName.push(distinctserviceCategory[dsc].serviceCategoryName);
                  }

                  const datasets: any[] = [];
                  this.colorCount=1;
                      columnName.forEach((_dataColumn, idxCl) => {
                        
                          subColumnName.forEach((_dataSubColumn, idxScl) => {
                             
                              this.chartData=[];
                              const backgroundColors: string[] = [];
                              const hoverColors: string[] = [];
                              const colors = this.chartService.getChartColors(this.colorCount);
                              this.colorCount++
                               serviceCategoryName.forEach((_dataCatColumn, idxScl) => {                               
                            
                                    const _filteredData = data.dashboardPopupBarChart.filter(
                                      item => item.columnName === _dataColumn 
                                      && item.subColumnName===_dataSubColumn
                                      && item.serviceCategoryName===_dataCatColumn
                                    );                                    
                                   
                                    if(_filteredData.length>0){
                                      this.chartData.push(_filteredData[0].columnValue);
                                    }
                                    else{
                                        this.chartData.push(0);
                                    }
                                });

                                datasets.push({
                                label: `${_dataSubColumn} (${_dataColumn})`,
                                data: this.chartData,
                                backgroundColor: colors.base, // unique color per dataset
                                hoverBackgroundColor: colors.hover ,
                                stack:_dataColumn
                              });
                                
                          });

                            

                        
                      });
                      console.log("datasets",datasets);
                      console.log("subColumnName",subColumnName);
                      this.barChartLabels = serviceCategoryName;
                      this.barChartData = datasets;

              
                
            }
            else
            {
              console.log("Else");
              const subColumnName=[];
              const columnName=[];
              this.barChartData=[];
              this.barChartLegend=true;

              const distinctColumn = data.dashboardPopupBarChart.filter(
                (dashboardPopupBarChart, i, arr) => arr.findIndex(t => t.columnName === dashboardPopupBarChart.columnName) === i
              );

              for (let dc = 0; dc < distinctColumn.length; dc++) {
                columnName.push(distinctColumn[dc].columnName);
              }

              const distinctSubColumn = data.dashboardPopupBarChart.filter(
                (dashboardPopupBarChart, i, arr) => arr.findIndex(t => t.subColumnName === dashboardPopupBarChart.subColumnName) === i
              );
              for (let dsc = 0; dsc < distinctSubColumn.length; dsc++) {
                subColumnName.push(distinctSubColumn[dsc].subColumnName);
              }
              const datasets: any[] = [];

                  columnName.forEach((_dataColumn, idxCl) => {
                    
                     this.chartData=[];
                     const colors = this.chartService.getChartColors(idxCl);
                      subColumnName.forEach((_dataSubColumn, idxScl) => {
                         console.log("_dataColumn.hover -: ", _dataColumn," _dataSubColumn -:",_dataSubColumn);
                            const _filteredData = data.dashboardPopupBarChart.filter(
                            item => item.columnName === _dataColumn 
                            && item.subColumnName===_dataSubColumn
                            );
                              console.log("_filteredData.hover -: ", _filteredData);
                              if(_filteredData.length>0)
                              {
                                this.chartData.push(_filteredData[0].columnValue);
                              }
                              else{
                                  this.chartData.push(0);
                              }
                            
                            
                      });
                      console.log("colors.base -: ", colors.base);
                      console.log("colors.hover -: ", colors.hover);
                      datasets.push({
                        label: `${_dataColumn}`,
                        data: this.chartData,
                        backgroundColor: colors.base, // unique color per dataset
                        hoverBackgroundColor: colors.hover 
                      });

                    
                  });
                  console.log("datasets",datasets);
                   console.log("subColumnName",subColumnName);
                  this.barChartLabels = subColumnName;
                  this.barChartData = datasets;

           
            }
            
 
              
         } else {
          this.toastrAlertService.errorToastr(ress.errorMessage);
        }
      },
      error => {
        this.loaderService.hide();
        if (typeof error.error !== "undefined") {
          this.toastrAlertService.errorToastr(this.appTranslateService.getTranslate('generalError'));
        }
      }
    )

    this.barChartData =[];
    this.chartData=[];
    this.barChartLabels=[];
    this.barChartData=[];
    this.doughnutChartLabels =[];
    this.doughnutChartData=[];
    this.items=[];
    this.loaderService.hide();

  }
}

 addItem(newItem: string) { 
  this.items.push(newItem);   
    this.CreateChartSelectedDateWise()
  }

  closeActiveModal(value) {
    this.activeModal.close(true);
  }

    public chartClicked(e:any):void {
      //console.log(e);
    }

  public chartHovered(e:any):void {
     // console.log(e);
    }
}
